
    import { Vue, Component, Prop, Watch } from "vue-property-decorator";
    import moment from "moment";
    import getContractorsMultiselectConditions from "@/helpers/getContractorsMultiselectConditions";
    import ADD_TAGS_To_TASK from "@/apollo/projectActivities/AddProjectActivityTag.gql";
    import ADD_SKILLS_To_TASK from "@/apollo/projectActivities/AddProjectActivitySkill.gql";
    import ADD_SOFT_SKILLS_To_TASK from "@/apollo/projectActivities/AddProjectActivitySoftSkill.gql";
    import CREATE_SKILL from "@/apollo/skills/CreateSkill.gql";
    import CREATE_SOFT_SKILL from "@/apollo/skills/CreateSoftSkill.gql";
    import GET_CONTRACTOR_BY_PROJECT_ID from "@/apollo/contractors/GetContractorByProjectId.gql";
    import GET_PROJECT_ACTIVITY_TAGS from "@/apollo/Tags/GetProjectActivityTags.gql";
    import GET_PROJECT_ACTIVITY_SKILLS from "@/apollo/skills/GetProjectActivitySkills.gql";
    import GET_PROJECT_ACTIVITY_SOFT_SKILLS from "@/apollo/skills/GetProjectActivitySoftSkills.gql";
    import CREATE_PROJECT_ACTIVITY from "@/apollo/projectActivities/CreateActivity.gql";
    import UPDATE_PROJECT_ACTIVITY from "@/apollo/projectActivities/UpdateActivity.gql";
    import TypeOfVisitMultiselect from "@/components/autocompleteMultiselects/TypeOfVisitMultiselect.vue";
    import UPDATE_PROJECT_ACTIVITY_RELATED_DATA from "@/apollo/projectActivities/UpdateProjectActivityRelatedData.gql";
    import GET_PROJECT_WITH_DATES from "@/apollo/projects/GetProjectWithDates.gql";
    import CustomSkillsMultiselectNew from "@/components/autocompleteMultiselects/customOptions/CustomSkillsMultiselectNew.vue";
    import CustomSoftSkillsMultiselectNew from "@/components/autocompleteMultiselects/customOptions/CustomSoftSkillsMultiselectNew.vue";
    import ModalFullScreen from "@/components/modal/ModalFullScreenNew.vue";
    import DropdownFilter from "@/components/filters/DropdownFilterNew.vue";
    import FormDatepicker from "@/components/form/FormDatepicker.vue";
    import NewTimePicker from "@/components/projects/timeTracker/NewTimePickerNew.vue";
    import UiButton from "@/components/button/ui-button.vue";
    import FormTextarea from "@/components/form/FormTextarea.vue";
    import DeleteProjectTags from "@/apollo/Tags/DeleteProjectActivitiesTags.gql";
    import DeleteProjectSkills from "@/apollo/Tags/DeleteProjectActivitiesSkills.gql";
    import DeleteProjectSoftSkills from "@/apollo/projectActivities/DeleteProjectActivitiesSoftSkills.gql";
    import DELETE_DECLINED_VISIT_MATCHES from "@/apollo/declinedVisitMatches/DeleteDeclinedVisitMatches.gql";
    import FormGroup from "@/components/form/FormGroupNew.vue";
    import FormInputGroup from "@/components/form/FormInputGroupNew.vue";
    import ContractorsMultiselect from "@/components/autocompleteMultiselects/ContractorsMultiselectNew.vue";
    import ContractorsMultiselectWithBookmarks from "@/components/autocompleteMultiselects/ContractorsMultiselectWithBookmarks.vue";
    import ProjectsMultiselect from "@/components/autocompleteMultiselects/ProjectsMultiselectV2.vue";
    import ProjectTasksPrioritySelect from "@/components/autocompleteMultiselects/ProjectTasksPrioritySelect.vue";
    import ActivityDataForModal from "@/entities/modals/ActivityDataForModalNew";
    import UPSERT_PROFILE_BY_MANAGEMENT from "@/apollo/profile/profileDetails/management/UpsertProfileDetailsByManagement.gql";
    import { Contractor, Project } from "@/interface";
    import { Project_Activity } from "@/generated/graphql";
    import { NOTIFICATION } from "@/entities/Events";
    import Message from "@/data/notificationsMessages";
    import ModalContent from "@/components/modal/ModalContent.vue";
    import convertSecondsToReadable from "@/utils/convertSecondsToReadable";
    import LocationModal from "@/views/clients/LocationModal.vue";
    import GET_CONTRACTOR_BASIC_INFO from "@/apollo/contractors/GetContractorBasicInfo.gql";
    import VisitErrorNotificationContainer from "@/components/common/VisitErrorNotificationContainer.vue";
    import { ErrorNotificationData } from "@/components/common/VisitErrorNotification.vue";
    import TransportationMethodIcons from "@/components/common/TransportationMethodIcons.vue";
    import ClockIcon from "@/components/icons/ClockLightGray.vue";
    import getAuthData from "@/utils/getAuthData";
    import {
        createDateTimeInLocationTimezone,
        getTimezoneFromLocationString,
        displayTimeInLocationTimezone,
        serializeTimezone,
        deserializeTimezone,
    } from "@/utils/timezoneUtils";
    import { calculateTravelTimes } from "@/utils/googleMapsDistanceMatrix";
    import { VUE_GOOGLEMAP_API_KEY } from "@/data/constants";
    import GET_SMART_MATCH_CONFIG_BY_MANAGER from "@/apollo/smartMatch/GetSmartMatchConfigByManager.gql";
    import GET_SMART_MATCH_CONFIG_BY_ADMIN from "@/apollo/smartMatch/GetSmartMatchConfigByAdmin.gql";
    import GET_CONTRACTORS_WITH_PROFILE from "@/apollo/autocomplete-queries/GetContractorsWithProfile.gql";
    import GET_USER_PROFILE_BY_USER_ID from "@/apollo/user/GetUserProfileByUserId.gql";
    import GET_PROJECT_BOOKMARKS_BY_MANAGER from "@/apollo/smartMatch/GetProjectBookmarksByManager.gql";
    import GET_PROJECT_BOOKMARKS_BY_ADMIN from "@/apollo/smartMatch/GetProjectBookmarksByAdmin.gql";
    import GET_MANAGER_BY_USER_ID from "@/apollo/smartMatch/GetManagerByUserId.gql";
    import GET_ADMIN_BY_USER_ID from "@/apollo/smartMatch/GetAdminByUserId.gql";
    import GET_CONTRACTOR_ACTIVITIES_WITH_PROJECTS from "@/apollo/projectActivities/GetContractorActivitiesWithProjects.gql";
    import ModalTabsNew from "@/components/modal/ModalTabsNew.vue";
    import InPersonVisit from "@/components/projects/activities/visitForms/inPersonVisit.vue";
    import VirtualVisit from "@/components/projects/activities/visitForms/virtualVisit.vue";

    interface NewActivity {
        title: string;
        startDate: string | null;
        endDate: string | null;
        created_at: string | null;
        extra_notes_updated_at: string | null;
        extra_notes_created_at: string | null;
        start_time: string | null;
        end_time: string | null;
        note: string;
        extra_notes: string;
        drafted: boolean;
        project_id: string;
        type_of_visit: null;
        location: string;
        selectedContractorsIds: string[];
        confirmedHours: number;
        timezone?: string | null;
    }

    interface ContractorListItem {
        id: string;
        name: string;
    }

    interface TimeObject {
        HH: string;
        mm: string;
    }

    export interface LocationTimezone {
        timeZoneId: string;
        timeZoneName: string;
        rawOffset: number;
        dstOffset: number;
    }

    enum ValidationMsg {
        PROJECT_START = "the project start date",
        PROJECT_END = "the project end date",
    }
    @Component({
        components: {
            ModalContent,
            ModalFullScreen,
            ModalTabsNew,
            InPersonVisit,
            VirtualVisit,
            TypeOfVisitMultiselect,
            DropdownFilter,
            ClockIcon,
            FormDatepicker,
            NewTimePicker,
            CustomSkillsMultiselectNew,
            CustomSoftSkillsMultiselectNew,
            UiButton,
            FormTextarea,
            ProjectTasksPrioritySelect,
            FormGroup,
            FormInputGroup,
            ContractorsMultiselect,
            ContractorsMultiselectWithBookmarks,
            ProjectsMultiselect,
            LocationModal,
            VisitErrorNotificationContainer,
            TransportationMethodIcons,
        },
        apollo: {
            contractors: {
                query: GET_CONTRACTOR_BY_PROJECT_ID,
                variables() {
                    return {
                        id: this.currentProject?.id,
                    };
                },
                update(data) {
                    this.projectLocation = data.project_by_pk.address;
                    this.contractors = data.project_by_pk;
                    return data.project_by_pk;
                },
                skip() {
                    return !this.currentProject.id;
                },
            },
            chosenProject: {
                query: GET_PROJECT_WITH_DATES,
                variables() {
                    const [id] = this.chosenProjectId;

                    return {
                        id,
                    };
                },
                skip() {
                    return this.shouldFetchProject;
                },
                update: (data) => data.project_by_pk,
            },
            skillIds: {
                query: GET_PROJECT_ACTIVITY_SKILLS,
                variables() {
                    return {
                        project_activity_id: this.projectActivity.id,
                    };
                },
                update(data): void {
                    this.skillsIds = data.project_activity_skill.map(({ skill_id }) =>
                        Number(skill_id)
                    );
                },
                skip(): boolean {
                    return !Boolean(this.projectActivity.id);
                },
            },
            softSkillIds: {
                query: GET_PROJECT_ACTIVITY_SOFT_SKILLS,
                variables() {
                    return {
                        project_activity_id: this.projectActivity.id,
                    };
                },
                update(data): void {
                    this.softSkillsIds = data.project_activity_soft_skill.map(({ soft_skill_id }) =>
                        Number(soft_skill_id)
                    );
                },
                skip(): boolean {
                    return !Boolean(this.projectActivity.id);
                },
            },
            tagsIds: {
                query: GET_PROJECT_ACTIVITY_TAGS,
                variables() {
                    return {
                        project_activity_id: this.projectActivity.id,
                    };
                },
                async update(data) {
                    const tagsIds = data.project_activity_tag.map((tag_id) => tag_id);
                    this.appliedTagId = await tagsIds.map((t) => t.tag_id);
                    this.loadingTags = true;
                },
                error(error) {
                    this.loadingTags = true;
                },
            },
            currentUser: {
                query: GET_CONTRACTOR_BASIC_INFO,
                variables() {
                    return {
                        id: this.userId,
                        userId: this.userId,
                        companyId: this.companyId,
                    };
                },
                update(data) {
                    this.contractId = data.contractor_by_pk.user.id;

                    // First check if user_job_title is available (new GraphQL field)
                    const profile = data.contractor_by_pk.user.profile as any;
                    if (profile?.user_job_title?.job_title) {
                        this.resourceJobTitle = true;
                        this.jobTitle = profile.user_job_title.job_title;
                    }
                    // Fallback to legacy job_title field
                    else if (profile?.job_title) {
                        this.resourceJobTitle = true;
                        this.jobTitle = profile.job_title;
                    }
                    // Fallback to management-set job title
                    else if (data.contractor_by_pk.user.user_profile_by_managements[0]?.job_title) {
                        this.resourceJobTitle = true;
                        this.jobTitle = data.contractor_by_pk.user.user_profile_by_managements[0]?.job_title;
                    } else {
                        this.resourceJobTitle = false;
                        this.jobTitle = "";
                    }

                    return data.contractor_by_pk;
                },
                skip(): boolean {
                    return Boolean(!this.showJobTitle);
                },
            },
        },
    })
    export default class ActivityFormModal extends Vue {
        @Prop({ type: Object, default: undefined }) readonly project?: Project;
        @Prop({ type: Object, default: undefined, required: false })
        readonly projectId?: string;
        @Prop({ type: Object, default: null })
        readonly projectActivity!: ActivityDataForModal | null;
        @Prop({ type: String, default: undefined }) readonly contractorId?: string;
        @Prop({ type: String, required: true }) readonly currentUserId!: string;
        @Prop({ type: String, required: true }) readonly currentUserRole!: string;
        @Prop({ type: String, required: true }) readonly companyId!: string;
        @Prop({ type: Boolean, default: false }) readonly isEdittingLocked!: boolean;
        @Prop({ type: Boolean, default: false }) readonly showProject: boolean;
        @Prop({ type: Boolean, default: true })
        readonly show_cancel_draft_actions: boolean;
        @Prop({ type: Object, default: undefined })
        readonly suggestedAssignee?: any;

        chosenProjectId: string[] = [];
        statusProcessing: boolean = false;

        // Tab management
        selectedTabIndex: number = 0;
        tabs: string[] = ['Field Visit', 'Virtual Visit'];

        contractors: [] = [];
        isLoading: boolean = false;
        skillsIds: number[] = [];
        newSkillsNames: string[] = [];
        allChosenSkills: any[] = [];
        skillsComponentKey: number = 0;
        softSkillsIds: number[] = [];
        newSoftSkillsNames: string[] = [];
        allChosenSoftSkills: any[] = [];
        softSkillsComponentKey: number = 0;
        appliedTagId: number[];
        contractId: string = "";
        projectLocation: string = "";
        loadingTags = false;
        selectedTagId: string[] = [];
        showJobTitle: boolean = false;
        userId: string = "";
        previousContractorIds: string = "";
        jobTitle: string = "";
        isMounted: boolean = false;
        resourceJobTitle: boolean = false;
        wasDrafted: boolean = false;
        chosenProject?: Project = undefined;
        currentUser?: Contractor = undefined;
        convertSecondsToReadable = convertSecondsToReadable;

        locationTimezone: LocationTimezone | null = null;

        // Smart Match functionality
        userManagerId: string | null = null;
        userAdminId: string | null = null;
        isUserAdmin: boolean = false;
        smartMatchConfig: any = null;
        projectBookmarks: Map<string, any> = new Map();
        smartMatchInitialized: boolean = false;
        userHasInteractedWithProjectDropdown: boolean = false;

        // Error notification functionality
        contractorValidationErrors: ErrorNotificationData[] = [];
        selectedContractorData: any = null;
        isValidatingContractor: boolean = false;

        // Travel time and location functionality
        travelTimesToPreviousVisit: any = {};
        hasOverlappingWithPreviousVisit: boolean = false;
        previousVisitLocation: string | null = null;
        availableTimeGapMinutes: number = 0;
        travelTimeConflicts: string[] = [];
        contractorName: string = '';

        activity: NewActivity = {
            title: "",
            startDate: null,
            start_time: null,
            end_time: null,
            endDate: null,
            created_at: null,
            extra_notes_created_at: null,
            extra_notes_updated_at: null,
            drafted: false,
            location: "",
            project_id: null,
            type_of_visit: null,
            note: "",
            extra_notes: "",
            confirmedHours: 0,
            selectedContractorsIds: [],
            timezone: null,
        };
        originalActivity: Project_Activity | null = null;

        async created(): Promise<void> {
            await this.initializeSmartMatchData();
            if (this.projectActivity) {
                const { confirmed_hours, requested_hours } = this.projectActivity;

                // If we have a suggested assignee, don't override the selection with original data
                const selectedContractorsIds = this.activity.selectedContractorsIds?.length > 0
                    ? this.activity.selectedContractorsIds
                    : this.projectActivity.contractor_id
                        ? [this.projectActivity.contractor_id]
                        : [];
                this.previousContractorIds = this.projectActivity.contractor_id;
                sessionStorage.setItem(
                    "allChoosentags",
                    JSON.stringify(this.projectActivity.project_activity_tags)
                );
                sessionStorage.setItem(
                    "allChoosenSkills",
                    JSON.stringify(this.projectActivity.project_activity_skills)
                );
                sessionStorage.setItem(
                    "allChoosenSoftSkills",
                    JSON.stringify(this.projectActivity.project_activity_soft_skills || [])
                );

                // Populate allChosenSkills and allChosenSoftSkills for validation in edit mode
                this.allChosenSkills = this.projectActivity.project_activity_skills?.map((activitySkill: any) => activitySkill.skill) || [];
                this.allChosenSoftSkills = this.projectActivity.project_activity_soft_skills?.map((activitySoftSkill: any) => activitySoftSkill.soft_skill) || [];

                // Only set the original contractor if we don't already have a suggested assignee selected
                if (this.projectActivity.contractor?.id && this.activity.selectedContractorsIds?.length === 0) {
                    this.showJobTitle = true;
                    this.userId = this.projectActivity.contractor.id;
                }
                this.wasDrafted = this.projectActivity.drafted;

                // Check if activity already has timezone data stored
                if (this.projectActivity.timezone) {
                    try {
                        this.locationTimezone = deserializeTimezone(
                            this.projectActivity.timezone
                        );
                    } catch (error) {
                        console.log("Error deserializing timezone:", error);
                    }
                }

                // Only fetch timezone from Google Maps API if we don't have it and we have a location
                if (!this.locationTimezone) {
                    const locationString =
                        this.projectActivity.location || this.projectLocation;
                    if (locationString) {
                        try {
                            this.locationTimezone = await getTimezoneFromLocationString(
                                locationString,
                                VUE_GOOGLEMAP_API_KEY
                            );
                        } catch (error) {
                            console.log(
                                "Error fetching timezone for existing location:",
                                error
                            );
                        }
                    }
                }

                this.activity = {
                    title: this.projectActivity.title || "",
                    startDate: this.projectActivity.start_time
                        ? moment(this.projectActivity.start_time).format()
                        : null,
                    endDate: this.projectActivity.end_date || null,
                    start_time: this.projectActivity.start_time
                        ? this.locationTimezone
                            ? displayTimeInLocationTimezone(
                                this.projectActivity.start_time,
                                this.locationTimezone,
                                "HH:mm"
                            )
                            : moment(this.projectActivity.start_time).format("HH:mm")
                        : null,

                    end_time: this.projectActivity.end_time
                        ? this.locationTimezone
                            ? displayTimeInLocationTimezone(
                                this.projectActivity.end_time,
                                this.locationTimezone,
                                "HH:mm"
                            )
                            : moment(this.projectActivity.end_time).format("HH:mm")
                        : null,
                    created_at: this.projectActivity.created_at || null,
                    extra_notes_created_at:
                        this.projectActivity?.extra_notes_created_at || null,
                    extra_notes_updated_at:
                        this.projectActivity?.extra_notes_updated_at || null,
                    project_id: this.projectActivity.project_id || null,
                    note: this.projectActivity.note || "",
                    location: this.projectActivity.location || this.projectLocation || "",
                    extra_notes: this.projectActivity.extra_notes || "",
                    type_of_visit: this.projectActivity.type_of_visit || null,
                    drafted: false,
                    confirmedHours:
                        Number(confirmed_hours / 3600) || 0 || requested_hours || 0,
                    selectedContractorsIds,
                };
                this.originalActivity = this.projectActivity
                    ? ({ ...this.projectActivity } as Project_Activity)
                    : null;

                // Set the correct tab based on whether it's a virtual visit
                // Tab 0 = In-Person Visit, Tab 1 = Virtual Visit
                if (this.projectActivity.virtual) {
                    this.selectedTabIndex = 1;
                } else {
                    this.selectedTabIndex = 0;
                }
            }

            this.chosenProjectId = this.project
                ? [this.project.id!]
                : this.projectId
                    ? [this.projectId]
                    : this.projectActivity?.project_id
                        ? [this.projectActivity.project_id]
                        : [];

            // For editing existing visits: if we have a project/client, consider it as "user interacted"
            // This enables smart match validation for editing visits without showing client selector
            if (this.projectActivity && (this.project || this.projectId || this.projectActivity.project_id)) {
                this.userHasInteractedWithProjectDropdown = true;

                // Load bookmarks immediately if smart match is enabled and we have a project
                const projectId = this.project?.id || this.projectId || this.projectActivity.project_id;

                if (this.shouldUseSmartMatchComponent && projectId) {
                    this.$nextTick(async () => {
                        await this.loadProjectBookmarks(projectId);

                        // Also trigger contractor validation if a contractor is already assigned
                        if (this.userId && this.activity.selectedContractorsIds?.length > 0) {
                            await this.validateContractor(this.userId);

                            // Also trigger travel time validation
                            const formattedStartTime = this.formatDateTime(this.activity.startDate, this.activity.start_time);
                            const formattedEndTime = this.formatDateTime(this.activity.startDate, this.activity.end_time);

                            if (formattedStartTime && formattedEndTime && this.activity.location) {
                                await this.checkContractorAvailability(formattedStartTime, formattedEndTime);
                            }
                        }
                    });
                }
                // If smart match is not available but we still have a contractor, validate basic info
                else if (this.userId && this.activity.selectedContractorsIds?.length > 0) {
                    this.$nextTick(async () => {
                        await this.validateContractor(this.userId);

                        // Also trigger travel time validation
                        const formattedStartTime = this.formatDateTime(this.activity.startDate, this.activity.start_time);
                        const formattedEndTime = this.formatDateTime(this.activity.startDate, this.activity.end_time);

                        if (formattedStartTime && formattedEndTime && this.activity.location) {
                            await this.checkContractorAvailability(formattedStartTime, formattedEndTime);
                        }
                    });
                }
            }

            // Don't load bookmarks automatically - wait for user to select a client
        }

        get isJobTitleDisabled(): boolean {
            return Boolean(this.resourceJobTitle || this.isEdittingLocked);
        }

        get disabledDates(): object {
            const today = new Date();
            today.setHours(0, 0, 0, 0); // Set to start of today

            return {
                to: new Date(today.getTime() - 1), // All dates before today (excluding today)
            };
        }

        mounted() {
            this.isMounted = true;
        }

        @Watch("projectLocation")
        onProjectLocationChanged(newLocation: string): void {
            if (!this.activity.location) {
                this.activity.location = newLocation;
            }
        }

        @Watch("chosenProjectId", { immediate: true })
        async onChosenProjectIdChanged(newProjectIds: string[]): Promise<void> {
            if (newProjectIds && newProjectIds.length > 0) {
                try {
                    const result = await this.$apollo.query({
                        query: GET_PROJECT_WITH_DATES,
                        variables: { id: newProjectIds[0] },
                    });

                    // Only set location from project address when creating new activities
                    // Don't override location when editing existing activities
                    if (result.data.project_by_pk && result.data.project_by_pk.address && !this.projectActivity?.id) {
                        this.activity.location = result.data.project_by_pk.address;
                    }
                } catch (error) {
                    console.log("Error fetching project data:", error);
                }
            }
        }

        @Watch("projectActivity", { immediate: true })
        onProjectActivityChanged(newActivity: any): void {
            // For editing: always use the project activity's location
            // For creating: only set if activity location is empty
            if (newActivity) {
                if (newActivity.id) {
                    // When editing, always use the project activity's location
                    this.activity.location = newActivity.location || "";
                } else if (!this.activity.location) {
                    // When creating, only set if no location is set yet
                    this.activity.location = newActivity.location || this.projectLocation || "";
                }
            }
            //   if (newActivity?.start_time) {
            //   this.activity.start_time = moment.utc(newActivity.start_time).local().format("HH:mm");
            // }

            // if (newActivity?.end_time) {
            //   this.activity.end_time = moment.utc(newActivity.end_time).local().format("HH:mm");
            // }
        }

        @Watch("suggestedAssignee", { immediate: true })
        async onSuggestedAssigneeChanged(newSuggestedAssignee: any): Promise<void> {

            // When we have a suggested assignee, populate activity data to work exactly like editing a visit
            // Remove isMounted check since immediate: true fires before mounted
            if (newSuggestedAssignee && !this.contractorId) {
                await this.setupSuggestedAssigneeAsContractor(newSuggestedAssignee);
            }
        }

        @Watch("activity.start_time", { immediate: true })
        onStartTimeChanged(newTime: any): void {
            this.checkAllTimeFieldsSet();
            const newTimeReadable = newTime
                ? typeof newTime === "string"
                    ? newTime
                    : `${newTime.HH}:${newTime.mm}`
                : null;
            if (newTime && this.activity.end_time) {
                let startTimeString = "";
                let endTimeString = "";
                this.activity.end_time;
                if (typeof newTime === "string") {
                    startTimeString = newTime;
                } else if (
                    newTime &&
                    typeof newTime === "object" &&
                    newTime.HH &&
                    newTime.mm
                ) {
                    startTimeString = `${newTime.HH}:${newTime.mm}`;
                } else {
                    return;
                }

                const endTime = this.activity.end_time;
                if (typeof endTime === "string") {
                    endTimeString = endTime;
                } else if (
                    endTime &&
                    typeof endTime === "object" &&
                    (endTime as any).HH &&
                    (endTime as any).mm
                ) {
                    const timeObj = endTime as TimeObject;
                    endTimeString = `${timeObj.HH}:${timeObj.mm}`;
                } else {
                    return;
                }

                const startMoment = moment(startTimeString, "HH:mm");
                const endMoment = moment(endTimeString, "HH:mm");

                if (
                    startMoment.isValid() &&
                    endMoment.isValid() &&
                    endMoment.isSameOrBefore(startMoment)
                ) {
                    this.activity.end_time = startMoment.add(1, "minute").format("HH:mm");
                }
            }
        }

        @Watch("activity.startDate", { immediate: true })
        onDateChanged(newDate: any): void {
            this.checkAllTimeFieldsSet();
        }

        @Watch("activity.end_time", { immediate: true })
        onEndTimeChanged(newTime: any): void {
            this.checkAllTimeFieldsSet();
            const newTimeReadable = newTime
                ? typeof newTime === "string"
                    ? newTime
                    : `${newTime.HH}:${newTime.mm}`
                : null;
            if (newTime && this.activity.start_time) {
                let startTimeString = "";
                let endTimeString = "";

                const startTime = this.activity.start_time;
                if (typeof startTime === "string") {
                    startTimeString = startTime;
                } else if (
                    startTime &&
                    typeof startTime === "object" &&
                    (startTime as any).HH &&
                    (startTime as any).mm
                ) {
                    const timeObj = startTime as TimeObject;
                    startTimeString = `${timeObj.HH}:${timeObj.mm}`;
                } else {
                    return;
                }

                if (typeof newTime === "string") {
                    endTimeString = newTime;
                } else if (
                    newTime &&
                    typeof newTime === "object" &&
                    (newTime as any).HH &&
                    (newTime as any).mm
                ) {
                    const timeObj = newTime as TimeObject;
                    endTimeString = `${timeObj.HH}:${timeObj.mm}`;
                } else {
                    return;
                }

                const startMoment = moment(startTimeString, "HH:mm");
                const endMoment = moment(endTimeString, "HH:mm");

                if (
                    startMoment.isValid() &&
                    endMoment.isValid() &&
                    endMoment.isSameOrBefore(startMoment)
                ) {
                    this.activity.end_time = startMoment.add(1, "minute").format("HH:mm");
                }
            }
        }

        @Watch("activity.location")
        async onLocationChanged(newLocation: string, oldLocation: string): Promise<void> {
            // Only recalculate if the location actually changed and both times are set
            if (newLocation !== oldLocation &&
                newLocation &&
                this.activity.start_time &&
                this.activity.end_time &&
                this.activity.selectedContractorsIds?.length > 0) {

                // Recalculate travel times to the previous visit by triggering availability check
                const formattedStartTime = this.formatDateTime(this.activity.startDate, this.activity.start_time);
                const formattedEndTime = this.formatDateTime(this.activity.startDate, this.activity.end_time);

                if (formattedStartTime && formattedEndTime && this.selectedContractorData) {
                    await this.checkContractorAvailability(formattedStartTime, formattedEndTime);
                }
            }
        }

        onProjectSelectionChanged(selectedProjects: string[]) {
            this.userHasInteractedWithProjectDropdown = true;
            this.chosenProjectId = selectedProjects;
        }

        async getContractorID(contrctorId) {
            this.userId = contrctorId[0];
            this.showJobTitle = true;
            if (!this.resourceJobTitle) {
                this.jobTitle = "";
            }

            // Validate contractor when one is selected (this sets selectedContractorData)
            if (contrctorId.length > 0) {
                await this.validateContractor(contrctorId[0]);

                // Now trigger travel time calculation after contractor data is set
                const formattedStartTime = this.formatDateTime(this.activity.startDate, this.activity.start_time);
                const formattedEndTime = this.formatDateTime(this.activity.startDate, this.activity.end_time);

                if (formattedStartTime && formattedEndTime && this.activity.location) {
                    await this.checkContractorAvailability(formattedStartTime, formattedEndTime);
                }
            } else {
                // Clear errors when no contractor is selected
                this.contractorValidationErrors = [];
                this.selectedContractorData = null;
            }
        }

        async setupSuggestedAssigneeAsContractor(suggestedAssignee: any): Promise<void> {
            try {

                // Find the contractor ID from the suggested assignee user data
                const userResult = await this.$apollo.query({
                    query: GET_CONTRACTORS_WITH_PROFILE,
                    variables: {
                        where: { user_id: { _eq: suggestedAssignee.id } },
                        limit: 1
                    },
                    fetchPolicy: 'network-only',
                });

                const contractor = userResult.data.contractor?.[0];
                if (!contractor) {
                    return;
                }

                // Populate activity data exactly like editing a visit with this contractor
                this.activity.selectedContractorsIds = [contractor.id];

                // Set userId for form validation (same as editing flow)
                this.userId = contractor.id;
                this.showJobTitle = true;


            } catch (error) {
                console.log('Error setting up suggested assignee as contractor:', error);
            }
        }


        get getConfirmedHoursInHours(): number {
            return Number(this.activity.confirmedHours) / 3600;
        }

        setTagId(tagId): void {
            if (tagId.length === 0) {
                this.selectedTagId = null;
                return;
            }
            const getTags = tagId.map((tag) => tag.id);
            const chosenTags = getTags;
            this.selectedTagId = chosenTags;
            sessionStorage.setItem("alltags", JSON.stringify(chosenTags));
        }

        get modalTitle(): string {
            return `${this.modalPurpose} Visit`;
        }

        updateTypeOfVisit(value) {
            this.$set(this.activity, "type_of_visit", value[0].id);
        }

        async handleSkillsListUpdated(skillsIdsFromDB: number[], newSkillsNames: string[], allChosenSkills: any[]): Promise<void> {
            this.newSkillsNames = newSkillsNames;
            this.allChosenSkills = allChosenSkills;

            // Create new skills immediately and update the selected list
            if (newSkillsNames.length > 0) {
                try {
                    const createdSkills = await this.createSkillsInDatabase(newSkillsNames);
                    const newSkillIds = createdSkills.map(skill => skill.id);

                    // Update the skillsIds to include both existing and newly created skills
                    this.skillsIds = [...skillsIdsFromDB, ...newSkillIds];

                    // Clear new skills names since they're now created
                    this.newSkillsNames = [];

                    // Force component to re-render with updated skills
                    this.skillsComponentKey += 1;

                } catch (error) {
                    console.log('Error creating new skills:', error);
                    // Keep the original skillsIds on error
                    this.skillsIds = skillsIdsFromDB;
                }
            } else {
                this.skillsIds = skillsIdsFromDB;
            }

            // Re-trigger contractor validation if a contractor is selected (to check skills validation)
            if (this.selectedContractorData) {
                await this.validateContractor(this.selectedContractorData.id);
            }
        }

        async handleSoftSkillsListUpdated(softSkillsIdsFromDB: number[], newSoftSkillsNames: string[], allChosenSoftSkills: any[]): Promise<void> {
            this.newSoftSkillsNames = newSoftSkillsNames;
            this.allChosenSoftSkills = allChosenSoftSkills;

            // Create new soft skills immediately and update the selected list
            if (newSoftSkillsNames.length > 0) {
                try {
                    const createdSoftSkills = await this.createSoftSkillsInDatabase(newSoftSkillsNames);
                    const newSoftSkillIds = createdSoftSkills.map(softSkill => softSkill.id);

                    // Update the softSkillsIds to include both existing and newly created soft skills
                    this.softSkillsIds = [...softSkillsIdsFromDB, ...newSoftSkillIds];

                    // Clear new soft skills names since they're now created
                    this.newSoftSkillsNames = [];

                    // Force component to re-render with updated soft skills
                    this.softSkillsComponentKey += 1;

                } catch (error) {
                    console.log('Error creating new soft skills:', error);
                    // Keep the original softSkillsIds on error
                    this.softSkillsIds = softSkillsIdsFromDB;
                }
            } else {
                this.softSkillsIds = softSkillsIdsFromDB;
            }

            // Re-trigger contractor validation if a contractor is selected (to check soft skills validation)
            if (this.selectedContractorData) {
                await this.validateContractor(this.selectedContractorData.id);
            }
        }

        get currentProject(): Project | undefined {
            return this.withContractor ? this.chosenProject : this.project;
        }

        get shouldUseSmartMatchComponent(): boolean {
            return this.smartMatchInitialized &&
                Boolean(this.smartMatchConfig?.smart_match_enabled) &&
                Boolean(this.userManagerId || this.userAdminId);
        }

        get shouldShowErrorNotifications(): boolean {
            // Show error notifications when:
            // 1. Smart match is initialized and enabled
            // 2. A contractor is selected
            // 3. User has interacted with project dropdown (similar to bookmark logic)
            // 4. User has manager/admin permissions
            return this.smartMatchInitialized &&
                Boolean(this.smartMatchConfig?.smart_match_enabled) &&
                this.userHasInteractedWithProjectDropdown &&
                Boolean(this.activity.selectedContractorsIds?.length > 0) &&
                Boolean(this.userManagerId || this.userAdminId);
        }

        get nonSchedulingValidationErrors() {
            return this.contractorValidationErrors.filter(error =>
                error.type !== 'scheduling' && error.type !== 'skills' && error.type !== 'soft_skills'
            );
        }

        get schedulingValidationErrors() {
            return this.contractorValidationErrors.filter(error =>
                error.type === 'scheduling' || error.type === 'travel'
            );
        }

        get skillsValidationErrors() {
            return this.contractorValidationErrors.filter(error => error.type === 'skills');
        }

        get softSkillsValidationErrors() {
            return this.contractorValidationErrors.filter(error => error.type === 'soft_skills');
        }

        get shouldShowNonSchedulingErrorNotifications(): boolean {
            return this.shouldShowErrorNotifications && this.nonSchedulingValidationErrors.length > 0;
        }

        get shouldShowSchedulingErrorNotifications(): boolean {
            return this.shouldShowErrorNotifications && this.schedulingValidationErrors.length > 0;
        }

        get shouldShowSkillsErrorNotifications(): boolean {
            return this.shouldShowErrorNotifications && this.skillsValidationErrors.length > 0;
        }

        get shouldShowSoftSkillsErrorNotifications(): boolean {
            return this.shouldShowErrorNotifications && this.softSkillsValidationErrors.length > 0;
        }

        get selectedProjectId(): string | null {
            return this.chosenProjectId?.length > 0 ? this.chosenProjectId[0] : null;
        }

        get availableTransportationMethods(): any[] {
            if (!this.selectedContractorData?.userProfile?.transportation) {
                return [];
            }
            return this.selectedContractorData.userProfile.transportation;
        }

        get shouldShowTransportationIcons(): boolean {
            return this.availableTransportationMethods.length > 0;
        }


        get isActiveProject(): boolean {
            return Boolean(this.projectActivity && !this.projectActivity.drafted);
        }

        get createdAt(): string {
            if (this.projectActivity?.id) {
                return moment(this.projectActivity?.created_at).format("DD MMM, YYYY");
            }
            return null;
        }

        get shouldFetchProject(): boolean {
            const isProjectChosen = Boolean(this.chosenProjectId.length);
            return !this.withContractor || !isProjectChosen;
        }

        get withContractor(): boolean {
            // Return true if:
            // 1. We have a contractorId prop (normal contractor editing mode)
            // 2. We have contractors selected in the activity (suggested assignee mode or form interactions)
            const result = Boolean(this.contractorId) || Boolean(this.activity.selectedContractorsIds?.length > 0);
            return result;
        }

        get shouldHideClientSelection(): boolean {
            // This method name is misleading - it actually controls the entire contractor/resource selection FormGroup
            // We should SHOW the contractor selection (return false) when:
            // 1. Creating a new visit (not isEdit)
            // 2. Editing a visit and need to reassign (isEdit but need contractor selection)
            // 3. In suggested assignee mode (we want to show the contractor selection with the suggested contractor)
            //
            // We should HIDE it (return true) only when:
            // 1. We have a contractorId prop AND we're not allowing reassignment

            // For now, let's always show the contractor selection unless we have specific reasons to hide it
            const shouldHide = false; // Always show contractor selection for now


            return shouldHide;
        }

        get isCreatedActivity(): boolean {
            return Boolean(this.projectActivity?.isNew);
        }

        // get activityDisabledDates(): DisabledDates {
        //   return {
        //     to: new Date(this.currentProject?.start_date),
        //     from: moment(this.currentProject?.end_date).add(1, "d").toDate(),
        //   };
        // }

        get modalPurpose(): string {
            return this.projectActivity?.id ? "Edit" : "Create";
        }

        get isEdit(): boolean {
            return this.projectActivity?.id ? true : false;
        }

        get buttonText(): string {
            if (!this.projectActivity?.id) return "Publish";
            if (this.projectActivity?.id && !this.projectActivity?.drafted)
                return "Update";
            if (this.projectActivity?.id && this.projectActivity?.drafted)
                return "Publish";
        }

        closeModal(): void {
            this.$root.$emit("projectsChanged");
            this.$emit("close");
            this.statusProcessing = false;
            this.isLoading = false;
        }

        updateTabIndex(index: number): void {
            this.selectedTabIndex = index;
        }
        locationAdded(enteredValue): void {
            this.activity.location = enteredValue.description;
            if (enteredValue.timezone) {
                this.locationTimezone = enteredValue.timezone;
            }
        }

        get startDateValidationRules(): string | object {
            if (!this.currentProject) {
                return {
                    project_required: [this.currentProject],
                };
            }

            const { start_date, end_date } = this.currentProject;
            const noBeforeProjectStart = `noBefore:${start_date},${ValidationMsg.PROJECT_START}`;
            const noAfterProjectEnd = `noAfter:${end_date},${ValidationMsg.PROJECT_END}`;
            const noAfterEndDate = this.activity.endDate ? "noAfter:@end_date" : "";
            return `${noBeforeProjectStart}|${noAfterEndDate}|${noAfterProjectEnd}|required_field`;
        }

        get contractorsNames(): ContractorListItem[] {
            return this.contractors.map(({ user, id }: Contractor) => ({
                id,
                name: `${user.given_name} ${user.family_name}`,
            }));
        }

        get contractorsConditions(): Object {
            return getContractorsMultiselectConditions(this.currentUserRole);
        }

        get projectsConditions(): Object[] {
            return [
                {
                    company_id: {
                        _eq: this.companyId,
                    },
                },
                {
                    completed: {
                        _eq: false,
                    },
                },
            ];
        }

        get rangeEndHourRange(): number[] {
            if (!this.activity.start_time) {
                return [];
            }

            const startTime = this.activity.start_time;
            let timeString = "";
            if (typeof startTime === "string") {
                timeString = startTime;
            } else if (
                startTime &&
                typeof startTime === "object" &&
                (startTime as any).HH &&
                (startTime as any).mm
            ) {
                const timeObj = startTime as TimeObject;
                timeString = `${timeObj.HH}:${timeObj.mm}`;
            } else {
                return [];
            }

            const startMoment = moment(timeString, "HH:mm");
            if (!startMoment.isValid()) {
                return [];
            }

            const startHour = startMoment.hour();
            const startMinute = startMoment.minute();

            const availableHours: number[] = [];

            if (startMinute < 59) {
                availableHours.push(startHour);
            }

            for (let hour = startHour + 1; hour <= 23; hour++) {
                availableHours.push(hour);
            }

            return availableHours;
        }

        get rangeEndMinuteRange(): number[] {
            if (!this.activity.start_time) {
                return [];
            }

            const startTime = this.activity.start_time;
            let timeString = "";
            if (typeof startTime === "string") {
                timeString = startTime;
            } else if (
                startTime &&
                typeof startTime === "object" &&
                (startTime as any).HH &&
                (startTime as any).mm
            ) {
                const timeObj = startTime as TimeObject;
                timeString = `${timeObj.HH}:${timeObj.mm}`;
            } else {
                return [];
            }

            const startMoment = moment(timeString, "HH:mm");
            if (!startMoment.isValid()) {
                return [];
            }

            const startHour = startMoment.hour();
            const startMinute = startMoment.minute();

            if (this.activity.end_time) {
                const endTime = this.activity.end_time;
                let endTimeString = "";
                if (typeof endTime === "string") {
                    endTimeString = endTime;
                } else if (
                    endTime &&
                    typeof endTime === "object" &&
                    (endTime as any).HH &&
                    (endTime as any).mm
                ) {
                    const timeObj = endTime as TimeObject;
                    endTimeString = `${timeObj.HH}:${timeObj.mm}`;
                }

                if (endTimeString) {
                    const endMoment = moment(endTimeString, "HH:mm");
                    if (endMoment.isValid()) {
                        const endHour = endMoment.hour();

                        if (endHour === startHour) {
                            const availableMinutes: number[] = [];
                            for (let minute = startMinute + 1; minute <= 59; minute++) {
                                availableMinutes.push(minute);
                            }
                            return availableMinutes;
                        }
                    }
                }
            }

            const allMinutes: number[] = [];
            for (let minute = 0; minute <= 59; minute++) {
                allMinutes.push(minute);
            }
            return allMinutes;
        }

        submitWithDraft(values) {
            return this.submit(values, true);
        }

        async submit(values, isDrafted = false): Promise<void> {
            this.isLoading = true;
            this.statusProcessing = true;

            // Fetch timezone if we don't have it yet and we have a location
            if (!this.locationTimezone && this.activity.location) {
                try {
                    this.locationTimezone = await getTimezoneFromLocationString(
                        this.activity.location,
                        VUE_GOOGLEMAP_API_KEY
                    );
                } catch (error) {
                    console.log("Error fetching timezone before submit:", error);
                }
            }

            const confirmedHoursInSeconds = this.activity.confirmedHours * 3600;

            const {
                selectedContractorsIds,
                title,
                note,
                startDate: start_date,
                start_time: start_time,
                end_time: end_time,
                endDate: end_date,
                extra_notes,
                created_at,
                location,
                type_of_visit,
                drafted,
                confirmedHours: confirmed_hours,
            } = values || this.activity;

            const formatTime = (time) => {
                if (typeof time === "string") {
                    return time;
                }

                if (time && time.HH && time.mm) {
                    const formattedTime = `${time.HH}:${time.mm}`;
                    return formattedTime;
                }

                return "00:00";
            };

            const formatDateTime = (date, time) => {
                if (!date || !time) {
                    return null;
                }

                const formattedTime = formatTime(time);

                const datePart = moment(date).format("YYYY-MM-DD");

                if (this.locationTimezone) {
                    return createDateTimeInLocationTimezone(
                        datePart,
                        formattedTime,
                        this.locationTimezone
                    );
                }

                const dateTimeString = `${datePart}T${formattedTime}:00`;

                const localDateTime = moment(dateTimeString);

                const utcDateTime = localDateTime.utc();

                return utcDateTime.toISOString();
            };
            const formattedStartTime = formatDateTime(
                this.activity.startDate,
                this.activity.start_time
            );
            const formattedEndTime = formatDateTime(
                this.activity.startDate,
                this.activity.end_time
            );

            const contractor_id = selectedContractorsIds[0] ?? this.contractorId ?? null;

            const resetValues =
                this.previousContractorIds !== contractor_id
                    ? {
                        accepted: null,
                        rejected: null,
                        accepted_on: null,
                        cancelled: null,
                        checkin_status: null,
                        checkin_time: null,
                        checkout_status: null,
                        checkout_time: null,
                        completed: false,
                        last_email_alert_at: null,
                        is_empty_visit_notify: false,
                    }
                    : {};

            const activity = {
                contractor_id,
                start_date,
                end_date,
                project_id:
                    this.activity.project_id ||
                    this.projectId ||
                    this.project?.id ||
                    this.chosenProjectId[0],
                start_time: formattedStartTime,
                end_time: formattedEndTime,
                location,
                timezone: this.locationTimezone
                    ? serializeTimezone(this.locationTimezone)
                    : null,
                created_at: moment(new Date()),
                extra_notes_created_at: extra_notes ? moment(new Date()) : null,
                extra_notes_updated_at: extra_notes ? moment(new Date()) : null,
                contractor_updated_at: contractor_id ? moment(new Date()) : null,
                title,
                type_of_visit: this.activity.type_of_visit,
                note,
                extra_notes,
                drafted: isDrafted,
                confirmed_hours: confirmedHoursInSeconds,
                ...resetValues, // Add the reset values when contractor changes
            };
            const updateActivity = {
                contractor_id,
                project_id:
                    this.activity.project_id ||
                    this.projectId ||
                    this.project?.id ||
                    this.chosenProjectId[0],
                start_time: formattedStartTime,
                end_time: formattedEndTime,
                start_date,
                end_date,
                title,
                note,
                type_of_visit: this.activity.type_of_visit,
                extra_notes,
                drafted: isDrafted,
                location,
                timezone: this.locationTimezone
                    ? serializeTimezone(this.locationTimezone)
                    : null,
                created_at,
                extra_notes_created_at:
                    extra_notes && !this.projectActivity?.extra_notes_created_at
                        ? moment(new Date())
                        : this.projectActivity?.extra_notes_created_at,
                extra_notes_updated_at: moment(new Date()),
                contractor_updated_at:
                    this.previousContractorIds !== contractor_id
                        ? moment(new Date())
                        : null,
                confirmed_hours: confirmedHoursInSeconds,
                ...resetValues, // Add the reset values when contractor changes
            };

            // Add created_by field only for new activities (not when editing)
            if (this.projectActivity?.isNew || !this.projectActivity) {
                (activity as any).created_by = this.currentUserId;
            }

            if (Boolean(!this.resourceJobTitle && this.jobTitle)) {
                await this.$apollo.mutate({
                    mutation: UPSERT_PROFILE_BY_MANAGEMENT,
                    variables: {
                        userId: this.contractId,
                        added_by_id: this.currentUserId,
                        profileByManagementSet: {
                            user_id: this.contractId,
                            added_by_id: this.currentUserId,
                            job_title: this.jobTitle || "",
                        },
                    },
                });
            }

            if (this.projectActivity?.isNew || !this.projectActivity) {
                await this.addActivity(activity);
                this.closeModal();
                this.closeModal();
                return;
            }

            const { id } = this.projectActivity!;

            // If contractor is being changed, cleanup any existing declined visit matches
            if (this.previousContractorIds !== contractor_id) {
                await this.cleanupDeclinedVisitMatches(id);
            }

            const updatedActivityData = { id, ...updateActivity };
            await this.updateActivityData(updatedActivityData, this.originalActivity);
            window.location.reload();
            this.closeModal();
        }

        async addActivity(activity: Partial<Project_Activity>): Promise<void> {
            try {
                const response = await this.createActivity(activity);
                const insert_project_one = response.data.insert_project_activity_one;
                await this.AttachTags(insert_project_one.id, this.selectedTagId);
                await this.AttachSkills(insert_project_one.id, this.skillsIds);
                await this.AttachSoftSkills(insert_project_one.id, this.softSkillsIds);
                if (insert_project_one?.contractor && !insert_project_one?.drafted) {
                    await this.triggerOfferedVisitEmail({
                        ...insert_project_one,
                        contractor: { ...this.currentUser, ...insert_project_one.contractor },
                    }).catch((e) => {
                        console.log('Error in handleSubmit callback:', e);
                    });
                }
                this.$emit("activityAdded", activity);
                this.$eventBus.emit(
                    NOTIFICATION,
                    Message.successMessage("Visit was created successfully.")
                );
            } catch (e) {
                console.log('Error creating activity:', e);
                console.log('Error details:', {
                    message: e.message,
                    graphQLErrors: e.graphQLErrors,
                    networkError: e.networkError,
                    fullError: e
                });
                this.$eventBus.emit(NOTIFICATION, Message.errorMessage(e.message));
            }
        }

        async triggerOfferedVisitEmail(activity) {
            const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const uri = `${process.env.VUE_APP_LAMBDA}/send-visit-offer-email`;
            const { headers } = await getAuthData();
            const { data }: any = await this.axios.post(
                uri,
                {
                    data: {
                        activity,
                        userTimezone,
                    },
                },
                { headers }
            );
        }

        async triggerVisitUpdatedEmail(activity, originalActivity) {
            const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const uri = `${process.env.VUE_APP_LAMBDA}/send-visit-updated-email`;
            const { headers } = await getAuthData();
            try {
                const { data }: any = await this.axios.post(
                    uri,
                    {
                        data: {
                            activity,
                            originalActivity,
                        },
                    },
                    { headers }
                );
            } catch (error) {
                console.log("Error sending visit updated email:", error);
            }
        }

        async deleteProjectTags(projId) {
            const tags = sessionStorage.getItem("allChoosentags");
            if (!tags) {
                return;
            }

            try {
                const parsedTags = JSON.parse(tags);
                if (parsedTags && parsedTags.length > 0) {
                    const getTagIds = parsedTags.map((item) =>
                        item.tag.id ? item.tag.id : item.tag
                    );
                    return await this.$apollo.mutate({
                        mutation: DeleteProjectTags,
                        variables: {
                            projectActivityId: projId ? projId : null,
                            tagIds: getTagIds.map((tagId) => tagId),
                        },
                    });
                }
            } catch (error) {
                console.log("Error parsing allChoosentags from session storage:", error);
                sessionStorage.removeItem("allChoosentags");
            }
        }

        async deleteProjectSkills(projId, skillId) {
            const skills = sessionStorage.getItem("allChoosenSkills");
            if (!skills) {
                return;
            }

            try {
                const parsedSkills = JSON.parse(skills);
                if (parsedSkills && parsedSkills.length > 0) {
                    const getSkillIds = parsedSkills.map((item) =>
                        item.skill.id ? item.skill.id : item.skill
                    );
                    return await this.$apollo.mutate({
                        mutation: DeleteProjectSkills,
                        variables: {
                            projectActivityId: projId ? projId : null,
                            skillIds: getSkillIds.map((skillId) => skillId),
                        },
                    });
                }
            } catch (error) {
                console.log("Error parsing allChoosenSkills from session storage:", error);
                sessionStorage.removeItem("allChoosenSkills");
            }
        }

        async deleteProjectSoftSkills(projId, softSkillId) {
            const softSkills = sessionStorage.getItem("allChoosenSoftSkills");
            if (!softSkills) {
                return;
            }

            try {
                const parsedSoftSkills = JSON.parse(softSkills);
                if (parsedSoftSkills && parsedSoftSkills.length > 0) {
                    const getSoftSkillIds = parsedSoftSkills.map((item) =>
                        item.soft_skill.id ? item.soft_skill.id : item.soft_skill
                    );
                    return await this.$apollo.mutate({
                        mutation: DeleteProjectSoftSkills,
                        variables: {
                            projId,
                            getSoftSkillIds,
                        },
                    });
                }
            } catch (error) {
                console.log("Error parsing allChoosenSoftSkills from session storage:", error);
                sessionStorage.removeItem("allChoosenSoftSkills");
            }
        }
        async updateActivityData(
            activity: Partial<Project_Activity>,
            originalActivity: Partial<Project_Activity>
        ): Promise<void> {
            try {
                const { id, ...activityData } = activity;
                const customRequestId = this.projectActivity?.custom_requests?.[0]?.id;
                const initialContractorSelected = !Boolean(
                    this.projectActivity?.contractor_id
                );
                const contractorSelected = Boolean(activity.contractor_id);

                if (customRequestId && contractorSelected && initialContractorSelected) {
                    const response = await this.updateProjectActivityAndRelatedData(
                        activity,
                        customRequestId
                    );
                    const insert_project_one = response.data.update_project_activity_by_pk;
                    if (!insert_project_one?.drafted) {
                        await this.triggerOfferedVisitEmail({
                            ...insert_project_one,
                            contractor: {
                                ...this.currentUser,
                                ...insert_project_one.contractor,
                            },
                        }).catch((e) => {
                            console.log('Error in handleSubmit callback:', e);
                        });
                    }
                } else {
                    const response = await this.updateBasicActivityData(id, activityData);
                    const insert_project_one = response.data.update_project_activity_by_pk;
                    if (
                        activity.start_date !== originalActivity.start_date ||
                        activity.start_time !== originalActivity.start_time ||
                        activity.end_time !== originalActivity.end_time ||
                        activity.location !== originalActivity.location
                    ) {
                        await this.triggerVisitUpdatedEmail(
                            {
                                ...insert_project_one,
                                contractor: {
                                    ...this.currentUser,
                                    ...insert_project_one.contractor,
                                },
                            },
                            { ...originalActivity }
                        );
                    }
                    if (
                        !insert_project_one?.drafted &&
                        activity.contractor_id &&
                        this.previousContractorIds !== activity.contractor_id
                    ) {
                        await this.triggerOfferedVisitEmail({
                            ...insert_project_one,
                            contractor: {
                                ...this.currentUser,
                                ...insert_project_one.contractor,
                            },
                        }).catch((e) => {
                            console.log('Error in handleSubmit callback:', e);
                        });
                    }
                }

                await this.deleteProjectTags(this.projectActivity.id);
                await this.deleteProjectSkills(
                    this.projectActivity.id,
                    this.selectedTagId
                );
                await this.deleteProjectSoftSkills(
                    this.projectActivity.id,
                    this.selectedTagId
                );
                await this.AttachTags(this.projectActivity.id, this.selectedTagId);
                await this.AttachSkills(this.projectActivity.id, this.skillsIds);
                await this.AttachSoftSkills(this.projectActivity.id, this.softSkillsIds);
                this.$emit("activityUpdated", activity);
                this.$eventBus.emit(
                    NOTIFICATION,
                    Message.successMessage("Visit was updated successfully.")
                );
            } catch (e) {
                console.log("Error updating activity:", e);
                this.$eventBus.emit(NOTIFICATION, Message.errorMessage(e.message));
            }
        }

        private createActivity(activity: Partial<Project_Activity>) {
            try {
                return this.$apollo.mutate({
                    mutation: CREATE_PROJECT_ACTIVITY,
                    variables: {
                        object: activity,
                    },
                });
            } catch (error) {
                console.log("Error creating activity:", error);
            }
        }

        private AttachTags(activity_id: string, tagId) {
            const tags = sessionStorage.getItem("alltags");
            if (tags) {
                const tagIds = JSON.parse(tags);
                const getTagIds = tagIds.map((item) => (item.id ? item.id : item));
                return this.$apollo.mutate({
                    mutation: ADD_TAGS_To_TASK,
                    variables: {
                        data: [
                            ...getTagIds.map((id) => ({
                                project_activity_id: activity_id ? activity_id : null,
                                tag_id: id,
                            })),
                        ],
                    },
                });
            }
        }

        private async createSkillsInDatabase(skillNames: string[]): Promise<any[]> {
            if (skillNames.length === 0) return [];

            try {
                const skillObjects = skillNames.map((name) => ({
                    name,
                    company_id: this.companyId,
                    user_id: this.currentUserId,
                }));

                const response = await this.$apollo.mutate({
                    mutation: CREATE_SKILL,
                    variables: {
                        objects: skillObjects,
                    },
                });

                return response.data.insert_skill.returning;
            } catch (error) {
                console.log('Error creating skills:', error);
                throw error;
            }
        }

        private async createSoftSkillsInDatabase(softSkillNames: string[]): Promise<any[]> {
            if (softSkillNames.length === 0) return [];

            try {
                const softSkillObjects = softSkillNames.map((name) => ({
                    name,
                    company_id: this.companyId,
                    user_id: this.currentUserId,
                }));

                const response = await this.$apollo.mutate({
                    mutation: CREATE_SOFT_SKILL,
                    variables: {
                        objects: softSkillObjects,
                    },
                });

                return response.data.insert_soft_skill.returning;
            } catch (error) {
                console.log('Error creating soft skills:', error);
                throw error;
            }
        }

        private async AttachSkills(activity_id: string, skillsIds, newSkillsNames: string[] = []) {
            try {
                // Since skills are created immediately in handleSkillsListUpdated,
                // we should only use the skillsIds (which already include created skills)
                const getSkillIds = skillsIds?.map((item) => (item.id ? item.id : item));
                if (getSkillIds && getSkillIds.length > 0) {
                    return this.$apollo.mutate({
                        mutation: ADD_SKILLS_To_TASK,
                        variables: {
                            data: getSkillIds.map((skillId) => ({
                                project_activity_id: activity_id,
                                skill_id: skillId,
                            })),
                        },
                    });
                }
            } catch (error) {
                console.log('Error attaching skills:', error);
                throw error;
            }
        }

        private async AttachSoftSkills(activity_id: string, softSkillsIds, newSoftSkillsNames: string[] = []) {
            try {
                // Since soft skills are created immediately in handleSoftSkillsListUpdated,
                // we should only use the softSkillsIds (which already include created soft skills)
                const getSoftSkillIds = softSkillsIds?.map((item) => (item.id ? item.id : item));
                if (getSoftSkillIds && getSoftSkillIds.length > 0) {
                    return this.$apollo.mutate({
                        mutation: ADD_SOFT_SKILLS_To_TASK,
                        variables: {
                            data: getSoftSkillIds.map((softSkillId) => ({
                                project_activity_id: activity_id,
                                soft_skill_id: softSkillId,
                            })),
                        },
                    });
                }
            } catch (error) {
                console.log('Error attaching soft skills:', error);
                throw error;
            }
        }

        private updateProjectActivityAndRelatedData(
            activity: Partial<Project_Activity>,
            customRequestId: string
        ) {
            const { id, ...setActivity } = activity;
            return this.$apollo.mutate({
                mutation: UPDATE_PROJECT_ACTIVITY_RELATED_DATA,
                variables: {
                    id,
                    set: setActivity,
                    customRequestId,
                },
            });
        }

        private updateBasicActivityData(
            id: string,
            activity: Partial<Project_Activity>
        ) {
            return this.$apollo.mutate({
                mutation: UPDATE_PROJECT_ACTIVITY,
                variables: {
                    id,
                    set: activity,
                },
            });
        }

        @Watch('selectedProjectId')
        async onProjectSelected(newProjectId: string | null, oldProjectId?: string | null) {
            if (this.shouldUseSmartMatchComponent) {
                if (newProjectId && this.userHasInteractedWithProjectDropdown) {
                    await this.loadProjectBookmarks(newProjectId);
                } else {
                    this.projectBookmarks = new Map();
                }
            } else {
                this.projectBookmarks = new Map();
            }
        }

        @Watch('shouldUseSmartMatchComponent')
        onShouldUseSmartMatchComponentChanged(shouldUse: boolean) {
            if (!shouldUse) {
                this.projectBookmarks = new Map();
            } else if (shouldUse && this.selectedProjectId && this.userHasInteractedWithProjectDropdown) {
                this.loadProjectBookmarks(this.selectedProjectId);
            }
        }

        async initializeSmartMatchData(): Promise<void> {
            try {
                // First try to get manager ID from the user ID
                let managerResult;
                try {
                    managerResult = await this.$apollo.query({
                        query: GET_MANAGER_BY_USER_ID,
                        variables: {
                            userId: this.currentUserId,
                        },
                        fetchPolicy: 'network-only',
                    });
                } catch (error) {
                    // Silent fallback to admin check
                }

                // If no manager found, try to get admin ID
                if (!managerResult?.data.manager.length) {
                    try {
                        const adminResult = await this.$apollo.query({
                            query: GET_ADMIN_BY_USER_ID,
                            variables: {
                                userId: this.currentUserId,
                            },
                            fetchPolicy: 'network-only',
                        });

                        if (adminResult.data.admin.length) {
                            this.userAdminId = adminResult.data.admin[0].id;
                            this.isUserAdmin = true;
                        }
                    } catch (error) {
                        // Silent fallback
                    }
                } else {
                    this.userManagerId = managerResult.data.manager[0].id;
                    this.isUserAdmin = false;
                }

                // Load smart match config if we have a manager or admin ID
                if (this.userManagerId || this.userAdminId) {
                    await this.loadSmartMatchConfig();
                }

                this.smartMatchInitialized = true;
            } catch (error) {
                console.log('Error initializing smart match data:', error);
            }
        }

        async loadSmartMatchConfig(): Promise<void> {
            try {
                const query = this.isUserAdmin ? GET_SMART_MATCH_CONFIG_BY_ADMIN : GET_SMART_MATCH_CONFIG_BY_MANAGER;
                const variables = this.isUserAdmin
                    ? { adminId: this.userAdminId }
                    : { managerId: this.userManagerId };

                const result = await this.$apollo.query({
                    query,
                    variables,
                    fetchPolicy: 'network-only',
                });

                this.smartMatchConfig = result.data.smart_match_configs?.[0] || null;
            } catch (error) {
                console.log('Error loading smart match config:', error);
            }
        }

        async loadProjectBookmarks(projectId: string): Promise<void> {
            try {
                const query = this.isUserAdmin ? GET_PROJECT_BOOKMARKS_BY_ADMIN : GET_PROJECT_BOOKMARKS_BY_MANAGER;
                const variables = this.isUserAdmin
                    ? { admin_id: this.userAdminId, project_id: projectId }
                    : { manager_id: this.userManagerId, project_id: projectId };

                const result = await this.$apollo.query({
                    query,
                    variables,
                    fetchPolicy: 'network-only',
                });

                const bookmarks = result.data.smart_match_bookmark || [];
                this.projectBookmarks = new Map();
                bookmarks.forEach(bookmark => {
                    this.projectBookmarks.set(bookmark.user_id, bookmark);
                });
            } catch (error) {
                console.log('Error loading project bookmarks:', error);
            }
        }

        async validateContractor(contractorId: string): Promise<void> {
            // Prevent multiple simultaneous validations
            if (this.isValidatingContractor) {
                return;
            }

            this.isValidatingContractor = true;

            try {
                // Clear previous errors
                this.contractorValidationErrors = [];

                if (!contractorId) {
                    this.isValidatingContractor = false;
                    return;
                }

                // Fetch contractor basic data
                const contractorResult = await this.$apollo.query({
                    query: GET_CONTRACTORS_WITH_PROFILE,
                    variables: {
                        where: { id: { _eq: contractorId } },
                        limit: 1
                    },
                    fetchPolicy: 'network-only',
                });

                const contractor = contractorResult.data.contractor[0];

                if (!contractor) {
                    return;
                }

                // Fetch user profile data (for skills, languages, transportation)
                const userProfileResult = await this.$apollo.query({
                    query: GET_USER_PROFILE_BY_USER_ID,
                    variables: {
                        userId: contractor.user.id
                    },
                    fetchPolicy: 'network-only',
                });

                const userProfile = userProfileResult.data.user_profile?.[0] || null;

                // Fetch contractor basic info to get address data
                const contractorBasicResult = await this.$apollo.query({
                    query: GET_CONTRACTOR_BASIC_INFO,
                    variables: {
                        id: contractorId,
                        companyId: this.companyId,
                        userId: this.currentUserId
                    },
                    fetchPolicy: 'network-only',
                });

                const contractorBasicInfo = contractorBasicResult.data.contractor_by_pk;
                const addressProfile = contractorBasicInfo?.user?.profile;
                const contractorName = `${contractor.user.given_name} ${contractor.user.family_name}`;

                // Store contractor data for future validations
                this.selectedContractorData = {
                    ...contractor,
                    userProfile: userProfile,
                    addressProfile: addressProfile
                };

                if (userProfile?.DNU_flag && this.shouldShowErrorNotifications) {
                    this.contractorValidationErrors.push({
                        type: 'dnu',
                        message: `${contractorName} has been flagged as Do Not Use.`,
                        show: true,
                        contractorName: contractorName,
                    });
                }

                // Validation 2: Language Check (Static - always shown regardless of smart match config)
                await this.validateContractorLanguages(contractorName, userProfile);

                // Validation 3: Skills Check (Dynamic - only if smart match config enables required_skills)
                await this.validateContractorSkills(contractorName, userProfile);

                // Validation 4: Soft Skills Check (Dynamic - only if smart match config enables soft_skills)
                await this.validateContractorSoftSkills(contractorName, userProfile);

                // Validation 5: Support Type Check (Static - always shown when project has support types)
                await this.validateContractorSupportTypes(contractorName, userProfile, contractor, contractorBasicInfo);

                // Validation 6: Certification Expiration Check (Static - always shown when certifications are expiring)
                await this.validateContractorCertifications(contractorName, contractor);
            } catch (error) {
                console.log('Error validating contractor:', error);
            } finally {
                this.isValidatingContractor = false;
            }
        }

        async validateContractorLanguages(contractorName: string, userProfile: any): Promise<void> {
            try {
                // Skip language validation if no project is selected
                if (!this.chosenProjectId || this.chosenProjectId.length === 0) {
                    return;
                }

                // Fetch fresh project data to ensure we have language fields
                let project;
                try {
                    const result = await this.$apollo.query({
                        query: GET_PROJECT_WITH_DATES,
                        variables: { id: this.chosenProjectId[0] },
                        fetchPolicy: 'cache-first',
                    });
                    project = result.data.project_by_pk;
                } catch (error) {
                    console.log('Error fetching project data for language validation:', error);
                    return;
                }
                const clientName = project?.firstname || project?.lastname || project?.client_name || 'Client';

                // Skip if no language requirements are set
                if (!project?.preferred_language && (!project?.communication_languages_spoken || project?.communication_languages_spoken.length === 0)) {
                    return;
                }

                // Get contractor's languages
                const contractorLanguages = userProfile?.languages || [];

                // Get smart match config for proficiency requirements (if available)
                const requiredProficiency = this.smartMatchConfig?.preferred_language_proficiency || 2; // Default to fluent level

                // Check preferred language
                if (project.preferred_language) {
                    const speaksPreferredLang = contractorLanguages.find(lang =>
                        lang.language.name.toLowerCase() === project.preferred_language.toLowerCase()
                    );

                    if (!speaksPreferredLang) {
                        // Contractor doesn't speak the preferred language at all
                        this.contractorValidationErrors.push({
                            type: 'language',
                            message: `${contractorName} does not speak ${clientName}'s preferred language.`,
                            show: true,
                            contractorName: contractorName,
                        });
                    } else if (speaksPreferredLang.proficiency_level > requiredProficiency) {
                        // Contractor speaks the language but not fluently enough (higher number = lower proficiency)
                        const proficiencyNames = {
                            1: 'Native',
                            2: 'Fluent',
                            3: 'Conversational',
                            4: 'Basic'
                        };

                        const contractorProficiency = proficiencyNames[speaksPreferredLang.proficiency_level] || 'Unknown';

                        this.contractorValidationErrors.push({
                            type: 'language',
                            message: `${contractorName} does not fluently speak ${clientName}'s preferred language. ${contractorName} is only ${contractorProficiency} in ${speaksPreferredLang.language.name}.`,
                            show: true,
                            contractorName: contractorName,
                        });
                    }
                }

                // Check communication languages (if different from preferred)
                if (project.communication_languages_spoken && project.communication_languages_spoken.length > 0) {
                    // Check if any communication language is different from preferred
                    const hasNonPreferredLang = project.communication_languages_spoken.some(lang => lang !== project.preferred_language);

                    if (hasNonPreferredLang) {
                        const communicationLangs = project.communication_languages_spoken;

                        const unmetLanguages = [];
                        const lowProficiencyLanguages = [];

                        communicationLangs.forEach(commLang => {
                            const speaksCommLang = contractorLanguages.find(lang =>
                                lang.language.name.toLowerCase() === commLang.toLowerCase()
                            );

                            if (!speaksCommLang) {
                                unmetLanguages.push(commLang);
                            } else if (speaksCommLang.proficiency_level > requiredProficiency) {
                                lowProficiencyLanguages.push({
                                    name: commLang,
                                    proficiency: speaksCommLang.proficiency_level
                                });
                            }
                        });

                        // Show error for unmet communication languages
                        if (unmetLanguages.length > 0) {
                            const langList = unmetLanguages.length > 1
                                ? unmetLanguages.slice(0, -1).join(', ') + ' or ' + unmetLanguages.slice(-1)
                                : unmetLanguages[0];
                            this.contractorValidationErrors.push({
                                type: 'language',
                                message: `${contractorName} does not speak ${clientName}'s communication language(s): ${langList}.`,
                                show: true,
                                contractorName: contractorName,
                            });
                        }

                        // Show error for low proficiency in communication languages
                        if (lowProficiencyLanguages.length > 0) {
                            const proficiencyNames = {
                                1: 'Native',
                                2: 'Fluent',
                                3: 'Conversational',
                                4: 'Basic'
                            };

                            const langProficiencyList = lowProficiencyLanguages
                                .map(lang => `${proficiencyNames[lang.proficiency]} in ${lang.name}`)
                                .join(', ');

                            this.contractorValidationErrors.push({
                                type: 'language',
                                message: `${contractorName} does not fluently speak ${clientName}'s communication languages. ${contractorName} is only ${langProficiencyList}.`,
                                show: true,
                                contractorName: contractorName,
                            });
                        }
                    }
                }
            } catch (error) {
                console.log('Error validating contractor languages:', error);
            }
        }

        async validateContractorSkills(contractorName: string, userProfile: any): Promise<void> {

            try {
                // Skip skills validation if smart match config doesn't enable it
                if (!this.smartMatchConfig?.required_skills_enabled) {
                    return;
                }

                // Skip skills validation if no skills are selected for this activity
                if (!this.allChosenSkills || this.allChosenSkills.length === 0) {
                    return;
                }

                // Get contractor's skills from userProfile
                const contractorSkills = userProfile?.skills || [];
                const contractorSkillIds = contractorSkills.map(userSkill => userSkill.skill?.id || userSkill.skill_id || userSkill.id);

                // Find missing skills (skills required by activity but not possessed by contractor)
                const missingSkills = this.allChosenSkills.filter(requiredSkill => {
                    const requiredSkillId = requiredSkill.id;
                    return !contractorSkillIds.includes(requiredSkillId);
                });

                // If there are missing skills, add error with chips
                if (missingSkills.length > 0) {
                    this.contractorValidationErrors.push({
                        type: 'skills',
                        message: `${contractorName} does not have the following selected skills:`,
                        show: true,
                        contractorName: contractorName,
                        additionalData: {
                            missingSkills: missingSkills
                        }
                    });
                }
            } catch (error) {
                console.log('Error validating contractor skills:', error);
            }
        }

        async validateContractorSoftSkills(contractorName: string, userProfile: any): Promise<void> {

            try {
                // Skip soft skills validation if smart match config doesn't enable it
                if (!this.smartMatchConfig?.soft_skills_enabled) {
                    return;
                }

                // Skip soft skills validation if no soft skills are selected for this activity
                if (!this.allChosenSoftSkills || this.allChosenSoftSkills.length === 0) {
                    return;
                }

                // Get contractor's soft skills from userProfile
                const contractorSoftSkills = userProfile?.user_soft_skills || [];
                const contractorSoftSkillIds = contractorSoftSkills.map(userSoftSkill => userSoftSkill.soft_skill?.id || userSoftSkill.soft_skill_id);

                // Find missing soft skills (soft skills required by activity but not possessed by contractor)
                const missingSoftSkills = this.allChosenSoftSkills.filter(requiredSoftSkill => {
                    const requiredSoftSkillId = requiredSoftSkill.id;
                    return !contractorSoftSkillIds.includes(requiredSoftSkillId);
                });

                // If there are missing soft skills, add error with chips
                if (missingSoftSkills.length > 0) {
                    this.contractorValidationErrors.push({
                        type: 'soft_skills',
                        message: `${contractorName} does not have the following selected soft skills:`,
                        show: true,
                        contractorName: contractorName,
                        additionalData: {
                            missingSoftSkills: missingSoftSkills
                        }
                    });
                }
            } catch (error) {
                console.log('Error validating contractor soft skills:', error);
            }
        }

        async validateContractorSupportTypes(contractorName: string, userProfile: any, contractor: any, contractorBasicInfo: any): Promise<void> {
            try {
                // Skip support type validation if no project is selected
                if (!this.chosenProjectId || this.chosenProjectId.length === 0) {
                    return;
                }

                // Fetch fresh project data to ensure we have support_type field
                let project;
                try {
                    const result = await this.$apollo.query({
                        query: GET_PROJECT_WITH_DATES,
                        variables: { id: this.chosenProjectId[0] },
                        fetchPolicy: 'cache-first',
                    });
                    project = result.data.project_by_pk;
                } catch (error) {
                    console.log('Error fetching project for support type validation:', error);
                    return;
                }

                if (!project) {
                    return;
                }

                // Skip validation if project has no support types
                if (!project.support_type) {
                    return;
                }

                // Parse project support_type (stored as PostgreSQL array string like {"value1","value2"})
                let projectSupportTypes: string[] = [];
                try {
                    if (typeof project.support_type === 'string') {
                        if (project.support_type.startsWith('{') && project.support_type.endsWith('}')) {
                            // PostgreSQL array format: {"Personal Support Worker (PSW)","Registered Nurse (RN)"}
                            const cleanedString = project.support_type.slice(1, -1); // Remove { }
                            projectSupportTypes = cleanedString
                                .split('","')
                                .map(item => item.replace(/^"|"$/g, '')); // Remove quotes
                        } else {
                            // Single value or other string format
                            projectSupportTypes = [project.support_type];
                        }
                    } else if (Array.isArray(project.support_type)) {
                        // Already an array
                        projectSupportTypes = project.support_type;
                    }
                } catch (error) {
                    console.log('Error parsing support_type:', error);
                    return;
                }

                if (projectSupportTypes.length === 0) {
                    return;
                }

                // Get contractor's job title from contractorBasicInfo (same pattern as working code)
                const profile = contractorBasicInfo?.user?.profile;
                let contractorJobTitle = '';

                // First check if user_job_title is available (new GraphQL field)
                if (profile?.user_job_title?.job_title) {
                    contractorJobTitle = profile.user_job_title.job_title;
                }
                // Fallback to legacy job_title field
                else if (profile?.job_title) {
                    contractorJobTitle = profile.job_title;
                }
                // Fallback to management-set job title
                else if (contractorBasicInfo?.user?.user_profile_by_managements?.[0]?.job_title) {
                    contractorJobTitle = contractorBasicInfo.user.user_profile_by_managements[0].job_title;
                }


                if (!contractorJobTitle) {
                    // Add error if contractor has no job title but project requires specific support types
                    this.contractorValidationErrors.push({
                        type: 'support_types',
                        message: `${contractorName} does not match the following support types: ${projectSupportTypes.join(', ')}`,
                        contractorName: contractorName,
                        show: true
                    });
                    return;
                }


                // Check for exact match between contractor's job title and any required support type
                const hasMatch = projectSupportTypes.some(supportType => {
                    const contractorNormalized = contractorJobTitle.toLowerCase().trim();
                    const supportTypeNormalized = supportType.toLowerCase().trim();
                    const isMatch = contractorNormalized === supportTypeNormalized;


                    return isMatch;
                });


                if (!hasMatch) {
                    // Add support type error for mismatch
                    this.contractorValidationErrors.push({
                        type: 'support_types',
                        message: `${contractorName} does not match the support types: ${projectSupportTypes.join(', ')}`,
                        contractorName: contractorName,
                        show: true
                    });
                }

            } catch (error) {
                console.log('Error validating contractor support types:', error);
            }
        }

        async validateContractorCertifications(contractorName: string, contractor: any): Promise<void> {
            try {
                // Get contractor's certifications
                const certifications = contractor?.user?.certifications || [];

                if (certifications.length === 0) {
                    return;
                }

                // Calculate date 3 months from now
                const now = moment();
                const threeMonthsFromNow = moment().add(3, 'months');

                // Find certifications expiring within the next 3 months
                const expiringCertifications = certifications.filter(cert => {
                    if (!cert.end_date) {
                        return false; // Skip certifications without an end date
                    }

                    const endDate = moment(cert.end_date);

                    // Check if end_date is between now and 3 months from now
                    return endDate.isAfter(now) && endDate.isBefore(threeMonthsFromNow);
                });

                // Add a warning for each expiring certification
                expiringCertifications.forEach(cert => {
                    const formattedEndDate = moment(cert.end_date).format('MMMM D, YYYY');

                    this.contractorValidationErrors.push({
                        type: 'certification',
                        message: `${cert.title} Certification expires ${formattedEndDate}`,
                        show: true,
                        contractorName: contractorName,
                        additionalData: {
                            certificationId: cert.id,
                            certificationTitle: cert.title,
                            endDate: cert.end_date
                        }
                    });
                });
            } catch (error) {
                console.log('Error validating contractor certifications:', error);
            }
        }

        async checkAllTimeFieldsSet(): Promise<void> {
            // Check if date is set
            if (!this.activity.startDate) return;

            // Check if start time is complete (both hour and minute)
            const startTime = this.activity.start_time as any;
            const isStartTimeComplete = startTime && (
                typeof startTime === "string" ||
                (startTime.HH && startTime.mm !== "")
            );

            // Check if end time is complete (both hour and minute)
            const endTime = this.activity.end_time as any;
            const isEndTimeComplete = endTime && (
                typeof endTime === "string" ||
                (endTime.HH && endTime.mm !== "")
            );

            if (isStartTimeComplete && isEndTimeComplete) {
                const formattedStartTime = this.formatDateTime(this.activity.startDate, this.activity.start_time);
                const formattedEndTime = this.formatDateTime(this.activity.startDate, this.activity.end_time);

                // Check for availability conflicts if contractor is selected
                if (this.selectedContractorData) {
                    await this.checkContractorAvailability(formattedStartTime, formattedEndTime);
                }
            }
        }

        formatDateTime(date: string | null, time: string | any): string | null {
            if (!date || !time) return null;

            try {
                const dateString = typeof time === "string" ? time : `${time.HH}:${time.mm}`;
                const dateFormatted = moment(date).format('YYYY-MM-DD');

                // Use location timezone if available (same logic as local formatDateTime function)
                if (this.locationTimezone) {
                    return createDateTimeInLocationTimezone(
                        dateFormatted,
                        dateString,
                        this.locationTimezone
                    );
                } else {
                    // Fallback to local timezone
                    const combinedDateTime = moment(`${dateFormatted} ${dateString}`, "YYYY-MM-DD HH:mm");
                    return combinedDateTime.isValid() ? combinedDateTime.format() : null;
                }
            } catch (error) {
                console.log('Error formatting date time:', error, { date, time });
                return null;
            }
        }

        async checkContractorAvailability(startTime: string | null, endTime: string | null): Promise<void> {
            if (!startTime || !endTime || !this.selectedContractorData) {
                return;
            }

            try {
                // Query for ALL contractor's project activities on the selected date
                const selectedDate = moment(startTime).format('YYYY-MM-DD');

                const result = await this.$apollo.query({
                    query: GET_CONTRACTOR_ACTIVITIES_WITH_PROJECTS,
                    variables: {
                        where: {
                            contractor_id: { _eq: this.selectedContractorData.id },
                            start_date: { _eq: selectedDate }, // Changed from _gte to _eq to get exact date match
                            // Removed drafted/cancelled filters to see all activities first
                        }
                    },
                    fetchPolicy: 'network-only',
                });

                const contractorActivities = result.data.project_activity || [];


                // Check for time overlaps with existing activities
                this.checkForSchedulingConflicts(contractorActivities, startTime, endTime);

                // Calculate travel times to the previous visit
                await this.calculateTravelTimesToPreviousVisit(contractorActivities, startTime);

            } catch (error) {
                console.log('Error checking contractor availability:', error);
            }
        }

        checkForSchedulingConflicts(existingActivities: any[], newStartTime: string, newEndTime: string): void {
            const contractorName = this.selectedContractorData ?
                `${this.selectedContractorData.user?.given_name} ${this.selectedContractorData.user?.family_name}` :
                'Contractor';

            // Remove any existing scheduling errors first
            this.contractorValidationErrors = this.contractorValidationErrors.filter(error => error.type !== 'scheduling');

            // Check each existing activity for time conflicts
            const conflictingActivities = existingActivities.filter(activity => {
                // Skip drafted, cancelled, or rejected activities
                if (activity.drafted || activity.cancelled || activity.rejected) {
                    return false;
                }

                // Get the visit location timezone offset for proper comparison
                let timezoneOffsetMinutes = -240; // Default to EDT (UTC-4 = -240 minutes)
                if (activity.timezone) {
                    try {
                        const timezoneData = typeof activity.timezone === 'string'
                            ? JSON.parse(activity.timezone)
                            : activity.timezone;
                        // rawOffset is in seconds, dstOffset is in seconds
                        if (timezoneData.rawOffset !== undefined && timezoneData.dstOffset !== undefined) {
                            timezoneOffsetMinutes = (timezoneData.rawOffset + timezoneData.dstOffset) / 60;
                        }
                    } catch (e) {
                        console.log('Failed to parse timezone data:', activity.timezone);
                    }
                }

                // Get the visit date for creating comparable moment objects
                const visitDate = moment(newStartTime).format('YYYY-MM-DD');

                // Convert existing activity times from UTC to visit location timezone
                const activityStartUTC = moment.utc(activity.start_time);
                const activityEndUTC = moment.utc(activity.end_time);
                const activityStartInVisitTZ = activityStartUTC.clone().add(timezoneOffsetMinutes, 'minutes');
                const activityEndInVisitTZ = activityEndUTC.clone().add(timezoneOffsetMinutes, 'minutes');

                // Create naive moment objects for comparison (same date, just time comparison)
                const activityStartTimeOnly = activityStartInVisitTZ.format('HH:mm:ss');
                const activityEndTimeOnly = activityEndInVisitTZ.format('HH:mm:ss');
                const activityStartLocal = moment(`${visitDate} ${activityStartTimeOnly}`, 'YYYY-MM-DD HH:mm:ss');
                const activityEndLocal = moment(`${visitDate} ${activityEndTimeOnly}`, 'YYYY-MM-DD HH:mm:ss');

                // Convert new visit times to visit location timezone
                // Since the form shows visit location address, treat the times as being in visit location timezone
                // Extract just the time portion and apply it to the visit location timezone
                const newStartTimeOnly = moment(newStartTime).format('HH:mm:ss');
                const newEndTimeOnly = moment(newEndTime).format('HH:mm:ss');

                // Create moment objects as naive times (no timezone) for comparison
                const newStartLocal = moment(`${visitDate} ${newStartTimeOnly}`, 'YYYY-MM-DD HH:mm:ss');
                const newEndLocal = moment(`${visitDate} ${newEndTimeOnly}`, 'YYYY-MM-DD HH:mm:ss');

                // Check if there's any overlap between the time ranges (both in visit location time)
                const condition1 = newStartLocal.isBefore(activityEndLocal);
                const condition2 = newEndLocal.isAfter(activityStartLocal);
                const hasOverlap = condition1 && condition2;

                return hasOverlap;
            });


            // Add scheduling error if conflicts found
            if (conflictingActivities.length > 0) {
                this.contractorValidationErrors.push({
                    type: 'scheduling',
                    message: `${contractorName} is already booked at this time.`,
                    show: true,
                    contractorName: contractorName,
                    additionalData: {
                        conflictingActivities: conflictingActivities
                    }
                });

            }
        }

        async calculateTravelTimesToPreviousVisit(contractorActivities: any[], newStartTime: string): Promise<void> {
            // Reset travel time data
            this.travelTimesToPreviousVisit = {};
            this.hasOverlappingWithPreviousVisit = false;
            this.previousVisitLocation = null;

            // Clear any existing scheduling and travel errors at the start
            this.contractorValidationErrors = this.contractorValidationErrors.filter(
                error => error.type !== 'scheduling' && error.type !== 'travel'
            );


            // Check required data for travel calculation
            if (!this.activity.location || !this.availableTransportationMethods.length) {
                return;
            }

            // If no activities exist, calculate travel time from contractor's home address
            if (!contractorActivities.length) {
                await this.calculateTravelTimesFromContractorHome();
                return;
            }

            // Parse the new visit times - ensure both times are in UTC for comparison
            const newStartMoment = moment.utc(newStartTime);
            const newEndTime = this.formatDateTime(this.activity.startDate, this.activity.end_time);
            const newEndMoment = moment.utc(newEndTime);


            // Find both previous and next visits for travel time calculation
            let previousVisit: any = null;
            let nextVisit: any = null;
            let closestPreviousTimeDiff = Infinity;
            let closestNextTimeDiff = Infinity;

            for (const activity of contractorActivities) {
                // Skip the current activity being edited to avoid self-overlap detection
                if (this.projectActivity && activity.id === this.projectActivity.id) {
                    continue;
                }

                // Skip drafted, cancelled, or rejected activities
                if (activity.drafted || activity.cancelled || activity.rejected) {
                    continue;
                }

                const activityStartMoment = moment.utc(activity.start_time);
                const activityEndMoment = moment.utc(activity.end_time);

                // Check for overlaps with new visit
                const overlapWithStart = newStartMoment.isBefore(activityEndMoment) && newEndMoment.isAfter(activityStartMoment);
                if (overlapWithStart) {
                    this.hasOverlappingWithPreviousVisit = true;
                }

                // Time difference calculations
                const timeDiffFromPrevious = newStartMoment.diff(activityEndMoment, 'minutes'); // Previous visit end → New visit start
                const timeDiffToNext = activityStartMoment.diff(newEndMoment, 'minutes'); // New visit end → Next visit start

                // Find the closest previous visit (activity ends before new visit starts)
                if (timeDiffFromPrevious > 0 && timeDiffFromPrevious < closestPreviousTimeDiff) {
                    closestPreviousTimeDiff = timeDiffFromPrevious;
                    previousVisit = activity;
                }

                // Find the closest next visit (activity starts after new visit ends)
                if (timeDiffToNext > 0 && timeDiffToNext < closestNextTimeDiff) {
                    closestNextTimeDiff = timeDiffToNext;
                    nextVisit = activity;
                }
            }

            // Skip if there's an overlap - but reset travel time data to show N/A
            if (this.hasOverlappingWithPreviousVisit) {
                // Set N/A for all transportation types when there's an overlap
                const overlapTimes: any = {};
                const transportationTypes = this.availableTransportationMethods.map(
                    (transport) => transport.transportation_type
                );

                transportationTypes.forEach(type => {
                    // Map transportation types to the API format for consistency
                    const apiFormat = type === 'public transit' ? 'transit' :
                        type === 'cycling' ? 'bicycling' : type;
                    overlapTimes[apiFormat] = 'N/A';
                });

                this.travelTimesToPreviousVisit = overlapTimes;
                this.travelTimeConflicts = []; // Clear conflicts
                this.availableTimeGapMinutes = 0; // Reset gap
                this.previousVisitLocation = null; // Reset location

                // Remove any existing travel time conflict errors
                this.contractorValidationErrors = this.contractorValidationErrors.filter(
                    error => error.type !== 'travel'
                );

                // Add overlap scheduling error
                const overlapErrorExists = this.contractorValidationErrors.some(
                    error => error.type === 'scheduling'
                );

                if (!overlapErrorExists) {
                    const errorMessage = this.contractorName
                        ? `${this.contractorName} has a scheduling conflict with an existing visit during this time period`
                        : `There is a scheduling conflict with an existing visit during this time period`;

                    this.contractorValidationErrors.push({
                        type: 'scheduling',
                        message: errorMessage,
                        show: true,
                        contractorName: this.contractorName,
                        additionalData: {
                            overlapDetected: true
                        }
                    });
                }


                return;
            }

            // Determine which visit to use for travel time calculation (prefer the tighter gap)
            let targetVisit: any = null;
            let timeGap = 0;
            let isNextVisit = false;

            if (previousVisit && nextVisit) {
                // Use the visit with the smaller time gap
                if (closestPreviousTimeDiff <= closestNextTimeDiff) {
                    targetVisit = previousVisit;
                    timeGap = closestPreviousTimeDiff;
                    isNextVisit = false;
                } else {
                    targetVisit = nextVisit;
                    timeGap = closestNextTimeDiff;
                    isNextVisit = true;
                }
            } else if (previousVisit) {
                targetVisit = previousVisit;
                timeGap = closestPreviousTimeDiff;
                isNextVisit = false;
            } else if (nextVisit) {
                targetVisit = nextVisit;
                timeGap = closestNextTimeDiff;
                isNextVisit = true;
            }


            if (!targetVisit) {
                return;
            }

            this.previousVisitLocation = targetVisit.location;
            this.availableTimeGapMinutes = timeGap;


            // Get contractor name for error messages
            if (this.selectedContractorData?.first_name && this.selectedContractorData?.last_name) {
                this.contractorName = `${this.selectedContractorData.first_name} ${this.selectedContractorData.last_name}`;
            }

            // Calculate travel times for each available transportation method
            try {
                const transportationTypes = this.availableTransportationMethods.map(
                    (transport) => transport.transportation_type
                );

                if (targetVisit.location === this.activity.location) {
                    // Set N/A for all transportation types when locations are the same
                    const sameLocationTimes: any = {};
                    transportationTypes.forEach(type => {
                        // Map transportation types to the API format for consistency
                        const apiFormat = type === 'public transit' ? 'transit' :
                            type === 'cycling' ? 'bicycling' : type;
                        sameLocationTimes[apiFormat] = 'N/A';
                    });

                    this.travelTimesToPreviousVisit = sameLocationTimes;
                } else {
                    // Calculate travel times based on direction
                    let origin: string, destination: string;
                    if (isNextVisit) {
                        // New visit → Next visit: travel from new location to next location
                        origin = this.activity.location;
                        destination = targetVisit.location;
                    } else {
                        // Previous visit → New visit: travel from previous location to new location
                        origin = targetVisit.location;
                        destination = this.activity.location;
                    }


                    try {
                        const travelTimes = await calculateTravelTimes(
                            origin,
                            destination,
                            VUE_GOOGLEMAP_API_KEY,
                            transportationTypes
                        );
                        this.travelTimesToPreviousVisit = travelTimes;
                    } catch (error) {
                        console.log('Google Maps API error:', error);
                        this.travelTimesToPreviousVisit = {};
                    }
                }

                // Detect travel time conflicts
                this.detectTravelTimeConflicts();

            } catch (error) {
                console.log('Error calculating travel times:', error);
            }
        }

        private detectTravelTimeConflicts(): void {
            // Reset conflicts
            this.travelTimeConflicts = [];

            // Remove any existing travel time conflict errors
            this.contractorValidationErrors = this.contractorValidationErrors.filter(
                error => error.type !== 'travel'
            );


            if (!this.travelTimesToPreviousVisit || this.availableTimeGapMinutes <= 0) {
                return;
            }

            // Parse travel times and compare with available time gap
            Object.entries(this.travelTimesToPreviousVisit).forEach(([mode, timeStr]) => {
                if (typeof timeStr !== 'string' || timeStr === 'N/A') {
                    return;
                }

                const travelTimeMinutes = this.parseTravelTimeToMinutes(timeStr);
                if (travelTimeMinutes > this.availableTimeGapMinutes) {
                    // Convert API format back to display format for error message
                    const displayMode = mode === 'transit' ? 'public transit' :
                        mode === 'bicycling' ? 'cycling' : mode;
                    this.travelTimeConflicts.push(displayMode);
                }
            });

            // Add travel time conflict error if any conflicts found
            if (this.travelTimeConflicts.length > 0) {
                const transportationMethods = this.travelTimeConflicts.join(', ');
                const errorMessage = this.contractorName
                    ? `${this.contractorName} has an earlier visit booked. Estimated travel time between visits may be an issue: ${transportationMethods}.`
                    : `There is an earlier visit booked. Estimated travel time between visits may be an issue: ${transportationMethods}.`;

                this.contractorValidationErrors.push({
                    type: 'travel',
                    message: errorMessage,
                    show: true,
                    contractorName: this.contractorName,
                    additionalData: {
                        conflictingMethods: this.travelTimeConflicts,
                        availableTimeGap: this.availableTimeGapMinutes,
                        travelTimes: this.travelTimesToPreviousVisit
                    }
                });
            }
        }

        private parseTravelTimeToMinutes(timeStr: string): number {
            try {
                // Parse strings like "15 min", "1 hour 23 min", "2 hours"
                const hourMatch = timeStr.match(/(\d+)\s*(?:hour|hr)s?/i);
                const minMatch = timeStr.match(/(\d+)\s*mins?/i);

                let totalMinutes = 0;

                if (hourMatch) {
                    totalMinutes += parseInt(hourMatch[1]) * 60;
                }

                if (minMatch) {
                    totalMinutes += parseInt(minMatch[1]);
                }

                // If no minutes found but hours found, assume it's just hours
                if (totalMinutes === 0 && hourMatch) {
                    totalMinutes = parseInt(hourMatch[1]) * 60;
                }

                // If no time components found, try to parse as just a number (assuming minutes)
                if (totalMinutes === 0) {
                    const numMatch = timeStr.match(/(\d+)/);
                    if (numMatch) {
                        totalMinutes = parseInt(numMatch[1]);
                    }
                }

                return totalMinutes;
            } catch (error) {
                console.log('Error parsing travel time:', timeStr, error);
                return 0;
            }
        }

        async calculateTravelTimesFromContractorHome(): Promise<void> {

            if (!this.selectedContractorData?.addressProfile) {
                return;
            }

            const profile = this.selectedContractorData.addressProfile;

            // Build contractor's home address string from profile data
            const addressParts = [];

            if (profile.address) addressParts.push(profile.address);
            if (profile.city) addressParts.push(profile.city);
            if (profile.state) addressParts.push(profile.state);
            if (profile.country) addressParts.push(profile.country);

            if (addressParts.length === 0) {
                return;
            }

            const contractorHomeAddress = addressParts.join(', ');


            // Get contractor name for error messages
            if (this.selectedContractorData?.user?.given_name && this.selectedContractorData?.user?.family_name) {
                this.contractorName = `${this.selectedContractorData.user.given_name} ${this.selectedContractorData.user.family_name}`;
            }

            // Calculate travel times for each available transportation method
            try {
                const transportationTypes = this.availableTransportationMethods.map(
                    (transport) => transport.transportation_type
                );


                const travelTimes = await calculateTravelTimes(
                    contractorHomeAddress,
                    this.activity.location,
                    VUE_GOOGLEMAP_API_KEY,
                    transportationTypes
                );

                this.travelTimesToPreviousVisit = travelTimes;

                // Since this is travel from home, we don't need to check for time conflicts
                // between visits (there are no other visits), so we just display the travel times

            } catch (error) {
                console.log('Error calculating travel times from home:', error);
                // Set N/A for all transportation types on error
                const errorTimes: any = {};
                this.availableTransportationMethods.forEach(transport => {
                    const apiFormat = transport.transportation_type === 'public transit' ? 'transit' :
                        transport.transportation_type === 'cycling' ? 'bicycling' :
                            transport.transportation_type;
                    errorTimes[apiFormat] = 'N/A';
                });
                this.travelTimesToPreviousVisit = errorTimes;
            }
        }

        async cleanupDeclinedVisitMatches(projectActivityId: string): Promise<void> {
            try {

                const result = await this.$apollo.mutate({
                    mutation: DELETE_DECLINED_VISIT_MATCHES,
                    variables: {
                        project_activity_id: projectActivityId
                    }
                });

                const affectedRows = result.data?.delete_declined_visit_matches?.affected_rows || 0;

            } catch (error) {
                // Don't throw the error - we don't want to block the re-assignment process
            }
        }
    }
